import React from 'react';
import PropTypes from 'prop-types';
import styles from './OverviewPaymentMethods.module.less';

const OverviewPaymentMethods = ({ ecmContent }) => {
  const { content, contentJson = { icons: [] } } = ecmContent;
  const { icons } = contentJson;
  return (
    <div className={styles.payment_methods_container}>
      <div dangerouslySetInnerHTML={{ __html: content }} />
      <div className={styles.logos_row_container}>
        {icons.map((src, index) => (
          <div key={index} className={styles.payment_method_logo_container}>
            <img className={styles.payment_method_logo} src={src} alt="" />
          </div>
        ))}
      </div>
    </div>
  );
};

OverviewPaymentMethods.propTypes = { ecmContent: PropTypes.object };
OverviewPaymentMethods.defaultProps = {
  ecmContent: { content: '', contentJson: { icons: [] } }
};

export default OverviewPaymentMethods;
